/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { KeyGenerate } from '../../../../types/KeyGenerate';

export const KeyGenerateRequest: core.serialization.Schema<
    serializers.KeyGenerateRequest.Raw,
    Omit<Truvity.KeyGenerateRequest, 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: KeyGenerate,
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace KeyGenerateRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data: KeyGenerate.Raw;
        labels?: Record<string, string> | null;
    }
}
